import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ProductGraphData } from '../../../Models/Models/PortfolioAnalysis/Performance/ProductGraphData';
import { IJsonDate } from '../../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientPerformanceValuationGraphClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(selectedIntervalStart: IJsonDate, selectedIntervalEnd: IJsonDate, fromInception: boolean, hierarchyIds: Array<string>, headAccountHierarchyIds: Array<string>): Promise<Array<ProductGraphData>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Performance/ClientPerformanceValuationGraph/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { selectedIntervalStart: selectedIntervalStart, selectedIntervalEnd: selectedIntervalEnd, fromInception: fromInception, hierarchyIds: hierarchyIds, headAccountHierarchyIds: headAccountHierarchyIds }

    return AjaxWrapper.get<Array<ProductGraphData>, any>(url, data);
  }
}

